// extracted by mini-css-extract-plugin
export default {"Modal":"Modal_Modal__nSdso","ModOn":"Modal_ModOn__NHeIM","ModOff":"Modal_ModOff__PFhnK","Img":"Modal_Img__5y-UF","ModalBG":"Modal_ModalBG__Klm7W","Absolute":"Modal_Absolute__N7C20"};